var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Redirect } from "react-router";
import Loader from "../Loader";
import { loadRestore as loadRestoreAction } from "../../actions/auth/creators/restore";
var isUserAuthenticated = function (user) {
    return user && Object.keys(user).length > 0 && user.constructor === Object;
};
var PrivateRoute = /** @class */ (function (_super) {
    __extends(PrivateRoute, _super);
    function PrivateRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tryRestore = function () {
            var _a = _this.props, user = _a.user, authenticated = _a.authenticated, isAuthenticating = _a.isAuthenticating, restore = _a.loadRestoreAction;
            if (!isUserAuthenticated(user) && authenticated && !isAuthenticating) {
                restore();
            }
        };
        return _this;
    }
    PrivateRoute.prototype.componentDidMount = function () {
        this.tryRestore();
    };
    PrivateRoute.prototype.componentDidUpdate = function () {
        this.tryRestore();
    };
    PrivateRoute.prototype.render = function () {
        var _a = this.props, RouteComponent = _a.component, render = _a.render, user = _a.user, authenticated = _a.authenticated, restore = _a.loadRestoreAction, isAuthenticating = _a.isAuthenticating, rest = __rest(_a, ["component", "render", "user", "authenticated", "loadRestoreAction", "isAuthenticating"]);
        if (isUserAuthenticated(user)) {
            return (_jsx(Route, __assign({}, rest, { render: function (props) {
                    if (render) {
                        return render(props);
                    }
                    if (RouteComponent) {
                        return _jsx(RouteComponent, __assign({}, props));
                    }
                    return null;
                } })));
        }
        if (authenticated) {
            return _jsx(Loader, {});
        }
        return _jsx(Redirect, { to: { pathname: "/" } });
    };
    return PrivateRoute;
}(Component));
PrivateRoute.propTypes = {
    component: PropTypes.func,
    render: PropTypes.func,
    user: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
    loadRestoreAction: PropTypes.func.isRequired
};
var mapStateToProps = function (state) { return ({
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    isAuthenticating: state.auth.isAuthenticating
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({ loadRestoreAction: loadRestoreAction }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/routing/PrivateRoute.jsx